import AuthenticationResource from "@ane/exp-data/lib/resources/AuthenticationResources";
import { getDefaultAsyncWrapperObj } from "@ane/core/lib/models";
import { loadResourcesUtils } from "@ane/core/lib/utils/LoadResourcesUtils";
const defaultReducerState = {
  res: getDefaultAsyncWrapperObj()
};
const prefix = "loadServicePrincipalNameList";
const CLEAR_DATA_SOURCE_STATE = `${prefix}/CLEAR_STATE`;
const clearLoadServicePrincipalNameListState = () => ({
  type: CLEAR_DATA_SOURCE_STATE
});
const loadServicePrincipalNameListArgs = {
  actionPrefix: `${prefix}/LOAD`,
  reduxKeyNested: () => ["res"],
  loadResource: (inputPayload) => {
    return AuthenticationResource.getServicePrincipalNameList(inputPayload.workspaceId);
  },
  onCompleteSuccess: (resourceResult) => {
    return resourceResult;
  }
};
const loadServicePrincipalNameListEpicReducer = loadResourcesUtils(loadServicePrincipalNameListArgs);
const loadServicePrincipalNameListReducer = (state = defaultReducerState, action) => {
  switch (action.type) {
    case CLEAR_DATA_SOURCE_STATE:
      return defaultReducerState;
    default:
      return loadServicePrincipalNameListEpicReducer.reduxChange(state, action);
  }
};
export {
  clearLoadServicePrincipalNameListState,
  loadServicePrincipalNameListReducer as default,
  defaultReducerState,
  loadServicePrincipalNameListEpicReducer,
  loadServicePrincipalNameListReducer
};
//# sourceMappingURL=ServicePrincipalList.ducks.js.map
